import { useState } from 'react';
import { Rss } from 'lucide-react';

/**
 * 通用订阅源 Logo 组件
 * 统一处理图片加载失败的兜底：未设置 logo 或图片加载失败时，
 * 显示默认 Logo（灰色底 + Rss 图标）。
 * 默认 Logo 样式统一在此组件内维护，后续调整只需修改这一处。
 *
 * @param {string} src    Logo 图片 URL，为空时直接显示默认 Logo
 * @param {string} title  订阅源名称，用于 img 的 alt
 * @param {number} size   尺寸（px），默认 32
 * @param {number} radius 圆角（px），默认 8
 * @param {string} className 追加的样式类
 */
export default function FeedLogo({ src, title = '', size = 32, radius = 8, className = '' }) {
  const [failed, setFailed] = useState(false);
  const boxStyle = { width: size, height: size, borderRadius: radius };

  // 图片存在且未加载失败时显示图片，否则显示默认 Logo
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={title}
        style={boxStyle}
        className={`object-cover flex-shrink-0 ${className}`}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      style={boxStyle}
      className={`bg-gray-100 flex items-center justify-center flex-shrink-0 ${className}`}
    >
      <Rss style={{ width: size / 2, height: size / 2 }} className="text-gray-400" />
    </div>
  );
}
